import React, {Component} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {isLoaded, withFirestore} from "react-redux-firebase";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {setProfileData, setProfilePicture} from "../../utils/AuthFunctions";
import DropzoneProfilePicture from "../../components/DropzoneProfilePicture";
import Dropzone from "react-dropzone";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import {CustomInput} from "../../components/Inputs";
import {COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {PROFILE_URL} from "../../constants/URLS";
import {StyledButton} from "../../components/Buttons";

class ProfileSettings extends Component {
    constructor() {
        super();
        this.state = {
            loaded: false,
            filled: true,
            firstN: '',
            lastN: '',
            email: '',
        }
    }

    setDefaultValues = () => {
        if(this.props.profile && isLoaded(this.props.profile) && !this.state.loaded){
            const {profile} = this.props
            this.setState({
                loaded: true,
                firstN: profile.firstN,
                lastN: profile.lastN,
                email: profile.email
            })
        }
    }

    componentDidMount() {
        this.setDefaultValues()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setDefaultValues()
    }


    render() {
        console.log(this.props)
        console.log(this.state)
        if(!this.state.loaded){
            return <div>Loading profile</div>
        }
        return (
            <div style={{maxHeight: '100vh', boxSizing: 'border-box', overflow: 'auto'}}>

            <BackgroundDiv/>

                <h2>Profile Settings</h2>
                <Dropzone accept={'image/*'} onDrop={async (files, acceptedFiles) => {
                    await setProfilePicture(
                        this.props.firebase,
                        files[0],
                        this.props.auth.uid
                    )
                }} multiple={false} >
                    {({getRootProps, getInputProps}) => (
                        <section>
                            <div className={'no-focus'} {...getRootProps()}>
                                <input {...getInputProps()} />
                                <DropzoneProfilePicture profile={this.props.profile}/>
                            </div>
                        </section>
                    )}
                </Dropzone>




                <div>
                    <CustomInput
                        value={this.state.firstN}
                        onChange={e=>{
                            this.setState({firstN: e.target.value})
                        }}
                        textTransform={'none'}
                    />
                    <CustomInput
                        value={this.state.lastN}
                        onChange={e=>{
                            this.setState({lastN: e.target.value})
                        }}
                        textTransform={'none'}
                    />


                    <StyledButton onClick={async () => {
                        await setProfileData(
                            this.props.firebase,
                            this.props.firestore,
                            this.props.auth.uid,
                            this.state.firstN,
                            this.state.lastN,
                        )
                        await this.props.history.push(PROFILE_URL)
                    }} disabled={!this.state.filled}>Update
                    </StyledButton>
                </div>




            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
)(ProfileSettings)